function entriesWithLink(items) {
  return items.flatMap((item) => {
    const childEntries = entriesWithLink(item.children);
    return item.link ? [item, ...childEntries] : childEntries;
  });
}

function matchesPath(link, path) {
  return path === link || path.startsWith(`${link}/`);
}

/** Id of the entry whose link is the path or a parent path of it; the longest link wins. */
export function findActiveItemId(items, path) {
  const matchingEntries = entriesWithLink(items).filter((entry) => matchesPath(entry.link, path));
  if (matchingEntries.length === 0) {
    return null;
  }

  const longestMatch = matchingEntries.reduce((longest, entry) =>
    entry.link.length > longest.link.length ? entry : longest
  );
  return longestMatch.id;
}
